import { base64Url } from './base64';

export function urlSnapshotToRedirectPath(): {
  to: string;
  query: string | null;
} {
  const baseUrl = new URL(window.location.hash.slice(1), window.location.origin);

  const searchParams: Record<string, string> = {};
  baseUrl.searchParams.forEach((value, key) => {
    if (key !== 'redirect' && key !== 'to') {
      searchParams[key as string] = value;
    }
  });

  const queryParams = Object.keys(searchParams).length ? JSON.stringify(searchParams) : null;

  return {
    to: baseUrl.pathname,
    query: queryParams ? base64Url(queryParams) : null,
  };
}
